import { push } from 'connected-react-router'

export default (path) => (dispatch) => dispatch(push(path))
